import API from "@/api/api";
import { DATA_API_SERVICE } from "@/appConfig";
import sortBy from "lodash/sortBy";
import ADREvent, { ADREventResponse } from "@/classes/adr";

async function getEvents() {
  try {
    const adrEventsResponse = await API.get<ADREventResponse[]>(`${DATA_API_SERVICE}/adr/events`);
    const mappedEvents = adrEventsResponse.data.map(event => ADREvent.fromAPI(event));
    return sortBy(mappedEvents, event => event.createdAt).reverse();
  } catch (e) {
    return [];
  }
}

const APIAdminADR = {
  getEvents
};

export default APIAdminADR;
